import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";

import TopicListDots from '../TopicDots/TopicListDots/TopicListDots';
import TopicHeaderDots from '../TopicDots/TopicHeaderDots/TopicHeaderDots';
import './TopicHeader.css';
import { generateRandomColor } from '../../helpers';
import { addBlock, changeTopic, toggleHeader, setTopic, saveColors, setCurrentPlayingId } from "../../actions/actions";
import CircularProgressBar from "../UI/CircularProgressBar/CircularProgressBar";

class TopicHeader extends Component {
	state = {
		isOpened: false,
		showingScript: false,
		showDotsContainer: false,
		currentlyPlayingTopic: null,
		playingBlockIndex: null,
		stopAllDotsAudio:false,
		animationState: false,
		updateTopicID: this.props.selectedTopicId,
		disableMenuButton: false,
		disableHeaderDotsPlayback: false,
		difficultyState: 2,      // 1 -> easy, 2 -> medium, 3 -> hard
		totalQuizTime: this.props.totalQuizTime,
		elapsedTime: 0,
		quizEnd: false,
		stopTimer: false,
		resetTimer: false,
		quizFinished: false,
		initialQuizState: false,
		disableSlider: false
	};

	menuButtonHandler = setAutomatically => {
		if (setAutomatically) {     // this variable is for walkthrough tooltips ONLY (for app-2)
			this.setState({ isOpened: this.props.topicListOpen }, () => { this.props.toggleHeader(this.state.isOpened) });
		} else {
			this.setState({ isOpened: !this.state.isOpened }, () => { this.props.toggleHeader(this.state.isOpened) });
		}
	};

	playButtonHandler = () => { this.props.scriptPlayHandler(this.props.selectedBlocks) };

	scriptButtonHandler = () => {
		this.props.scriptListHandler();
		if (this.props.selectedBlocks && this.props.selectedBlocks.length === 5) this.setState({ showingScript: true });
	};

	clearButtonHandler = () => {
		this.props.removeSequenceHandler();
		if (this.state.showingScript) this.props.scriptListHandler(true);
		this.setState({ showingScript: false });
	};

	matchPlayingId = () => {
		if (this.props.selectedBlocks && this.props.selectedBlocks.length > 0) {
			if (this.props.currentPlayingId) return [...this.props.selectedBlocks].find(block => block.id === this.props.currentPlayingId);
			else return true;
		}
	};

	changeTopicHandler = topicId => {
		let appTheme = '';
		const newTopic = [...this.props.topics].map(topic => {
			if (topic.id === topicId) {
				appTheme = topic.title
				topic.selected = true;
				this.props.setTopic({ selectedTopic: topic });
			} else topic.selected = false;
			return topic;
		});

		this.setState({ stopAllDotsAudio: true, isOpened: !this.state.isOpened }, () => { this.props.toggleHeader(this.state.isOpened) });
		this.props.saveColors({ topicColors: generateRandomColor(this.props.currentApp, appTheme) });
		this.props.changeTopic({
			topics: newTopic,
			selectedTopicId: topicId,
		});
		this.topicListButtonsHandler();
		this.clearButtonHandler();  // to de-select the sequence from previous topic and stop the current playing block
	};

	topicListButtonsHandler = type => {
		this.setState({ isOpened: false })
		this.props.toggleHeader(false);
		setTimeout(() => {    // calling this func after delay so that the topic list animation is let finished first
			if (type === 'help') this.props.helpButtonClicked();
			if (type === 'close') this.props.closeButtonClicked();
			if (type === 'quiz') {
				if (this.props.quizMode || this.state.initialQuizState) {
					this.setState({ initialQuizState: false })
					this.props.endQuizModeButtonClicked()
				} else {
					this.setState({ initialQuizState: true })
					this.props.showQuizIntro()
				}
			}
		}, 500);
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps !== this.props) {
			if (prevProps.topicListOpen !== this.props.topicListOpen) {
				if (!this.props.topicListOpen) this.topicListButtonsHandler();
				this.menuButtonHandler(true);
			}
			if (this.props.selectedTopicId !== prevProps.selectedTopicId) {
				this.setState({ updateTopicID: this.props.selectedTopicId })
			}
			if (prevProps.openTopicListAutomatically !== this.props.openTopicListAutomatically) {
				this.menuButtonHandler(true);
			}
			if (prevProps.quizMode !== this.props.quizMode) {
				if (this.props.quizMode) {
					this.setState({ initialQuizState: false, quizEnd: false })
				} else this.setState({ quizEnd: true, stopTimer: true })
			}

			if (prevProps.startQuizOver !== this.props.startQuizOver) {
				if (this.props.startQuizOver) this.setState({ startQuizOver: true })
			}

			if (prevProps.quizFinished !== this.props.quizFinished) {
				if (this.props.quizFinished) this.setState({ quizFinished: true })
			}

			if (this.props.updateQuizLevel !== prevProps.updateQuizLevel) {
				if (!!this.props.updateQuizLevel) {
					this.setState({ difficultyState: this.props.updateQuizLevel })
				}
			}

			if (prevProps.disableSlider !== this.props.disableSlider) {
				this.setState({ disableSlider: this.props.disableSlider })
			}
		}


		if (prevState !== this.state) {
			if (prevState.isOpened !== this.state.isOpened) {
				if (this.state.isOpened) this.setState({ showDotsContainer: false })    // hiding the dots container IF the topic menu is open
				if (!this.state.isOpened && this.state.showDotsContainer) this.setState({ showDotsContainer: false })   // IF the dot is clicked while the topic menu was open, we won't let the dot container show up right after the menu list is closed
			}

			if (prevState.currentlyPlayingTopic !== this.state.currentlyPlayingTopic) {
				this.setState({ disableHeaderDotsPlayback: !!this.state.currentlyPlayingTopic })
			}

			if (prevState.difficultyState !== this.state.difficultyState) {
				this.props.updateDifficultyState(this.state.difficultyState)
			}
		}
	}

	render() {
		const showingTopicLists = `option-select ${this.state.isOpened ? 'showing' : 'not-showing'} ${this.props.currentApp}`;
		const menuButtonClass = `hamburger-menu ${this.props.currentApp} theme-${this.props.selectedTopicId} ${this.state.isOpened ? 'showing' : ''} ${(this.state.disableMenuButton || !!this.props.currentPlayingId) ? 'disabled' : ''}`;
		const appHeaderStyle = this.props.topicListOpen ? { zIndex: '1051', background: '#fbfbfb' } : null;

		const active = (this.props.selectedBlocks && this.props.selectedBlocks.length === 5) ? `active ${this.props.currentApp}` : '';

		// clear button is disabled when there are no blocks selected OR there is no block playing
		const clearButtonDisabled = !((this.props.selectedBlocks && this.props.selectedBlocks.length > 0) || this.props.currentPlayingId);
		// play button is only to be shown when 5 blocks are selected (active). It gets disabled again, when we start playing blocks (props.currentPlyingId)
		const playButtonDisabled = !!this.props.currentPlayingId || !active;
		// script button will be disabled when less than 5 blocks are selected or if a block, other the selected blocks, is played
	    const scriptButtonDisabled = this.state.isOpened || (!!active && !this.matchPlayingId());

	    const clearButtonClass = `clear-button ${clearButtonDisabled ? 'button-disabled' : `active ${this.props.currentApp}`}`;
	    const scriptButtonClass = `script-button ${(active && !scriptButtonDisabled) ? active : ''} ${scriptButtonDisabled ? 'button-disabled' : ''}`;
	    const playButtonClass = `play-button ${playButtonDisabled ? 'button-disabled' : active}`;

		const scriptButton = this.props.showActiveOnly ? <span><i className='fa fa-th-large' /></span> : <div><i className='fa fa-comment' /></div>;
		/*
			to change the icon (svg) on build, the parent has to be changed.
			Switching between span and div fixes the bug.
			If same element (<span> or <div>) is used, as parent, on both conditions, the icon does not change
		*/

		const topicList = this.props.topics.map((topic, index) => {
			const topicTitle = (
				<span onClick={() => { this.changeTopicHandler(topic.id) }}>
					{
						this.props.topic.id === topic.id ?
						<div style={{ display: 'inline' }}>
							<i style={{ fontSize: '16px' }} className="fa fa-check fa-fw" />
						</div>
						: ''
					} {topic.title}
				</span>
			);

			const selectedClass = this.props.currentApp !== 'app-3' && this.props.topic.id === topic.id ? 'selected' : '';
			const topicListClass = `topic-title ${this.props.currentApp} ${selectedClass}`;
			const topicListStyle = {}, topicID = parseInt(topic.id);
			if (this.props.currentApp === 'app-3') {
				const bgColors = ['#F1A19D', '#FFD8A4', '#D59AB5', '#B2DBEA']
				topicListStyle["backgroundColor"] = bgColors.filter((color, i) => i === topicID - 1)
			}

			return (
				<li key={index} className={topicListClass} style={topicListStyle} >
					{topicTitle}
					{/* For Dots in the topic list */}
					{
						this.props.currentApp === 'app-2' ?
						<TopicListDots
							topicID={topic.id}
							currentlyPlayingTopic={this.state.currentlyPlayingTopic}
							setCurrentlyPlayingTopic={topic => this.setState({ stopAllDotsAudio: false, currentlyPlayingTopic: topic })}
							playingBlockIndex={this.state.playingBlockIndex}
							setPlayingBlockIndex={index => this.setState({ playingBlockIndex: index })}
							stopAllDotsAudio={this.state.stopAllDotsAudio}
							setAnimationState={state => this.setState({ animationState: state })}
							animationRunning={this.state.animationState}
						/>
						: null
					}
				</li>
			);
		});

		const topicListButtons = [
			(this.props.currentApp === 'app-3' ?
				<div key='quiz' className='quiz-button' onClick={() => this.topicListButtonsHandler('quiz')}>
					<span>{ this.props.quizMode || this.state.initialQuizState ? 'End Quiz Mode' : 'Quiz Mode' }</span>
				</div>
				: null
			),
			<div key='tutorial' className={`help-button ${this.props.currentApp} ${this.props.quizMode ? 'disabled' : ''}`} onClick={() => this.topicListButtonsHandler('help')}>
				<span style={{ fontSize: '30px', marginRight: '7px' }}>?</span>
				<span>Tutorial</span>
			</div>,
			<div key='close' className='close-app-button' onClick={() => this.topicListButtonsHandler('close')}>
				<i className="fa fa-times" style={{ fontSize: '25px', marginRight: '7px'}} />
				<span>Close App</span>
			</div>
		];

		const enableDotsContainer = (this.state.showDotsContainer && !this.state.isOpened && !this.state.disableHeaderDotsPlayback && !this.props.currentPlayingId);
		const topicHeaderDot = (
			// For dots in the Topic Header
			this.props.currentApp === 'app-2' ?
			<div className='topic-header-dot-wrapper'>
				<div className='topic-header-dot'
					style={{ backgroundColor: (this.state.disableHeaderDotsPlayback || !!this.props.currentPlayingId) ? '#eee' : 'rgb(255, 190, 43)' }}
			        onClick={() => this.setState({ showDotsContainer: !this.state.showDotsContainer })}
				/>
				<div className={`topic-header-dots-container ${enableDotsContainer ? 'show-dots-container' : 'hide-dots-container'}`} >
					<div className='topic-header-dots' >
						<TopicHeaderDots disableMenuButton={disable => this.setState({ disableMenuButton: disable })} />
					</div>
				</div>
			</div>
			: null
		);

		const topicTitle = (
			this.props.currentApp === 'app-3' && (this.state.initialQuizState || this.props.quizMode) ?
			<CircularProgressBar
				initialQuizState={this.state.initialQuizState}
				currentPara={ this.state.quizEnd ? 0 : this.props.quizStats[0] }
				totalPara={this.props.quizStats[1]}
				difficulty={this.state.difficultyState}
				startQuizOver={this.state.startQuizOver}
				quizStarted={() => {
					this.setState({ startQuizOver: false });
					this.props.quizStarted();
				}}
				quizFinished={this.state.quizFinished}
				resetQuizFinishedState={() => {
					this.setState({ quizFinished: false })
					this.props.resetQuizFinishedState()
				}}
				timeOver={() => this.props.timeOver()}
				elapsedTime={val => {
					this.setState({ stopTimer: false })
					this.props.elapsedTime(val)
				}}
			/>
			:
			this.props.topic.title.length > 30 ? this.props.topic.title.substr(0, 30) + "..."
			: this.props.topic.title
		);

		let topicHeaderControls = '';
		const difficulty = ['Slow', 'Normal', 'Fast'].filter((diff, i) => i === (this.state.difficultyState - 1));
		if (this.props.currentApp === 'app-3') {    // for the difficulty slider
			const sliderClass = `slider slider-${this.state.disableSlider ? 'disabled' : this.state.difficultyState}`;
			topicHeaderControls = (
				<div className={`slider-container ${this.props.quizMode || this.state.initialQuizState ? 'hidden' : ''}`}>
					<div className={difficulty}>
						<input type="range" min="1" max="3" step="1"
					       id='difficulty-slider' name='difficulty-slider'
					       value={this.state.difficultyState}
					       onChange={change => this.setState({ difficultyState: parseInt(change.target.value) })}
					       className={sliderClass}
						/>
					</div>
					<label htmlFor='difficulty-slider'>Speed: {difficulty}</label>
				</div>
			)
		} else {    // for the 3 buttons in topic header
			topicHeaderControls = [
				<div key='play-button' className={playButtonClass} onClick={ this.playButtonHandler }>
					<i className="fa fa-play" />
				</div>,
				<div key='script-button' className={scriptButtonClass} onClick={ this.scriptButtonHandler }>
					{scriptButton}
				</div>,
				<div key='close-button' className={clearButtonClass} onClick={ this.clearButtonHandler }>
					<i className="fa fa-times" />
				</div>
			];
		}

		return (
			<div className="matrix-app-header" style={appHeaderStyle}>
				<div className={menuButtonClass} onClick={() => this.menuButtonHandler()} >
					<i className="fa fa-bars fa-3x" />
				</div>
				<div className="title-bar-top">
					{topicTitle}
					{topicHeaderDot}
				</div>
				<div className={showingTopicLists} style={{ position: 'absolute' }}>
					<ul className="topic-list-container">
						{
							this.props.currentApp === 'app-3' ?
							[
								topicList[0],
								<div key={'topic-list-div-whatever'} className='topicList-tooltip-container'>
									{[topicList[1], topicList[2]]}
								</div>,
								topicList[3]
							]
							: topicList
						}
					</ul>
					<div className={`topic-list-buttons ${this.props.buttonsDisabled ? 'disabled' : ''}`} >
						{topicListButtons}
					</div>
				</div>
				<div className='topic-header-controls'>
					{topicHeaderControls}
				</div>
			</div>
		);
	}
}

TopicHeader.propTypes = {
	topics: PropTypes.array,
	topic: PropTypes.object,
	onHandleAddBlocksToSequence: PropTypes.func,
	scriptListHandler: PropTypes.func,
	scriptPlayHandler: PropTypes.func,
	menuButtonHandler: PropTypes.func,
	removeSequenceHandler: PropTypes.func,
};

const mapStateToProps = state => ({
	currentApp: state.appReducer.currentApp,
	selectedTopicId: state.topicListReducer.selectedTopicId,
	selectedBlocks: state.touchPadReducer.selectedBlocks,
	currentPlayingId: state.touchPadReducer.currentPlayingId,
	topicColors: state.topicListReducer.topicColors,
	topics: state.topicListReducer.topics,
	topic: state.topicListReducer.selectedTopic
});

const mapDispatchToProps = dispatch => ({
	changeTopic: params => dispatch(changeTopic(params)),
	addBlock: params => dispatch(addBlock(params)),
	toggleHeader: params => dispatch(toggleHeader(params)),
	setTopic: params => dispatch(setTopic(params)),
	saveColors: params => dispatch(saveColors(params)),
	setCurrentPlayingId: params => dispatch(setCurrentPlayingId(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(TopicHeader);